if (!customElements.get('header-pill-premium')) {
  customElements.define(
    'header-pill-premium',
    class HeaderPillPremium extends HTMLElement {
      connectedCallback() {
        if (this.isReady) return;
        this.isReady = true;
        this.drawer = this.querySelector('[data-pill-drawer]');
        this.openButton = this.querySelector('[data-pill-mobile-open]');
        this.closeButtons = this.querySelectorAll('[data-pill-close]');
        this.accordionToggles = this.querySelectorAll('[data-pill-accordion-toggle]');
        this.abortController = new AbortController();
        this.unlockPage();
        this.bindEvents();
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.unlockPage();
      }

      bindEvents() {
        const { signal } = this.abortController;

        this.openButton?.addEventListener('click', () => this.openDrawer(), { signal });

        this.closeButtons.forEach((button) => {
          button.addEventListener('click', () => this.closeDrawer(), { signal });
        });

        this.accordionToggles.forEach((button) => {
          button.addEventListener('click', () => this.toggleAccordion(button), { signal });
        });

        this.querySelectorAll('.pill-drawer a').forEach((link) => {
          link.addEventListener('click', () => this.closeDrawer(), { signal });
        });

        document.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'Escape') this.closeDrawer();
          },
          { signal }
        );

        window.addEventListener('resize', () => this.refreshOpenAccordions(), { signal });
      }

      openDrawer() {
        if (!this.drawer) return;
        this.drawer.removeAttribute('hidden');
        this.lockPage();
        window.requestAnimationFrame(() => {
          this.drawer.classList.add('is-open');
          this.openButton?.setAttribute('aria-expanded', 'true');
        });
      }

      closeDrawer() {
        if (!this.drawer || this.drawer.hasAttribute('hidden')) return;
        this.drawer.classList.remove('is-open');
        this.openButton?.setAttribute('aria-expanded', 'false');
        window.setTimeout(() => {
          if (!this.drawer.classList.contains('is-open')) {
            this.drawer.setAttribute('hidden', '');
            this.unlockPage();
          }
        }, 240);
      }

      toggleAccordion(button) {
        const item = button.closest('[data-pill-accordion]');
        const panel = item?.querySelector('[data-pill-accordion-panel]');
        if (!item || !panel) return;

        const isOpen = item.classList.contains('is-open');
        button.setAttribute('aria-expanded', String(!isOpen));

        if (isOpen) {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
          window.requestAnimationFrame(() => {
            item.classList.remove('is-open');
            panel.style.maxHeight = '0px';
          });
          window.setTimeout(() => {
            if (!item.classList.contains('is-open')) panel.setAttribute('hidden', '');
          }, 240);
          return;
        }

        panel.removeAttribute('hidden');
        panel.style.maxHeight = '0px';
        window.requestAnimationFrame(() => {
          item.classList.add('is-open');
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        });
      }

      refreshOpenAccordions() {
        this.querySelectorAll('[data-pill-accordion].is-open [data-pill-accordion-panel]').forEach((panel) => {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        });
      }

      lockPage() {
        if (window.BouquetScrollLock?.lock) {
          window.BouquetScrollLock.lock({
            owner: 'pill-header',
            className: 'pill-header-lock',
            target: document.documentElement,
          });
          return;
        }

        document.documentElement.classList.add('pill-header-lock');
      }

      unlockPage() {
        if (window.BouquetScrollLock?.unlock) {
          window.BouquetScrollLock.unlock({ owner: 'pill-header' });
          return;
        }

        document.documentElement.classList.remove('pill-header-lock');
      }
    }
  );
}
